/* eslint-disable @typescript-eslint/ban-ts-comment*/
/* eslint-disable prefer-const*/
/* eslint-disable @typescript-eslint/restrict-plus-operands*/
import React, { FC, useContext, useEffect, useMemo, useRef, useState } from "react";
import { AntmediaContext } from "../../App";
import _ from "lodash";
import MiniVideoCallControl from "./Components/video-call/mini-videocallcontrol"
import VideoCallControl from "./Components/video-call"
import MiniAudioCallControl from "./Components/audio-call/mini-callcontrol"
import AudioCallControl from "./Components/audio-call/index"

export const SettingsContext = React.createContext<any>(null);
export const MediaSettingsContext = React.createContext<any>(null);

const globals = {
  //this settings is to keep consistent with the sdk until backend for the app is setup
  // maxVideoTrackCount is the tracks i can see excluding my own local video.so the use is actually seeing 3 videos when their own local video is included.
  maxVideoTrackCount: 5,
};
type LocalData = {
  streamId: string,

}

interface IProps {
  meetingStatus: string;
  roomName: string;
  customerName: string;
  setMeetingStatus(status: string): void;
}
const DMSMedia: FC<IProps> = ({ meetingStatus, roomName, customerName, setMeetingStatus }) => {

  const antmedia = useContext(AntmediaContext);
  const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null);

  // drawerOpen for message components.
  const [drawerOpen, setDrawerOpen] = useState(false);

  // whenever i join the room, i will get my unique id and stream settings from webRTC.
  // So that whenever i did something i will inform other participants that this action belongs to me by sending my streamId.
  const [myLocalData, setMyLocalData] = useState<LocalData>();

  // this is my own name when i enter the room.
  const [streamName, setStreamName] = useState("");

  // this is for checking if i am sharing my screen with other participants.
  const [isScreenShared, setIsScreenShared] = useState(false);

  //we are going to store number of unread messages to display on screen if user has not opened message component.
  const [numberOfUnReadMessages, setNumberOfUnReadMessages] = useState(0);

  // pinned screen this could be by you or by shared screen.
  const [pinnedVideoId, setPinnedVideoId] = useState<string | null>(null);

  const [screenSharedVideoId, setScreenSharedVideoId] = useState<string | null>(null);

  // { id: "", track:{} },
  const [participants, setParticipants] = useState<any[]>([]);
  const [allParticipants, setAllParticipants] = useState<any[]>([]);
  const [audioTracks, setAudioTracks] = useState<any[]>([]);
  const [mic, setMic] = useState<any[]>([]);
  const [talkers, setTalkers] = useState<any[]>([]);
  const [isPublished, setIsPublished] = useState(false);
  const [selectedCamera, setSelectedCamera] = React.useState("");
  const [selectedMicrophone, setSelectedMicrophone] = React.useState("");

  const [messages, setMessages] = useState<any[]>([]);

  const [cam, setCam] = useState([
    {
      eventStreamId: "localVideo",
      isCameraOn: true, //start with camera on
    },
  ]);
  const handleSendNotificationEvent = (eventType: string, publishStreamId: any, info?: { streamId?: any; mic?: boolean; camera?: boolean; isPinned?: any; isScreenShared?: boolean; }) => {
    let notEvent = {
      streamId: publishStreamId,
      eventType: eventType,
      ...info,
    };
    antmedia.sendData(publishStreamId, JSON.stringify(notEvent));
  }
  const screenShareOffNotification = () => {
    if (myLocalData?.streamId)
      antmedia.handleSendNotificationEvent(
        "SCREEN_SHARED_OFF",
        myLocalData.streamId
      );
    //if i stop my screen share and if i have pin someone different from myself it just should not effect my pinned video.
    if (pinnedVideoId === "localVideo") {
      setPinnedVideoId(null);
    }
  }
  const handleNotifyPinUser = (id: string) => {
    // If I PIN USER then i am going to inform pinned user.
    // Why? Because if i pin someone, pinned user's resolution has to change for better visibility.
    if (myLocalData)
      handleSendNotificationEvent("PIN_USER", myLocalData.streamId, {
        streamId: id,
      });
  }

  const handleNotifyUnpinUser = (id: string) => {
    // If I UNPIN USER then i am going to inform pinned user.
    // Why? We need to decrease resolution for pinned user's internet usage.
    if (myLocalData)
      handleSendNotificationEvent("UNPIN_USER", myLocalData.streamId, {
        streamId: id,
      });
  }

  const pinVideo = (id: string, videoLabelProp = "") => {
    // id is for pinning user.
    let videoLabel = videoLabelProp;
    if (videoLabel === "") {
      // if videoLabel is missing select the first videoLabel you find
      // 1 -2 -3 -4 -5 -6 -7 -8 -9
      videoLabel = participants.find((p) => p.videoLabel !== p.id).videoLabel;
    }
    // if we already pin the targeted user then we are going to remove it from pinned video.
    if (pinnedVideoId === id) {
      setPinnedVideoId(null);
      handleNotifyUnpinUser(id);
      antmedia.assignVideoTrack(videoLabel, id, false);
    }
    // if there is no pinned video we are gonna pin the targeted user.
    // and we need to inform pinned user.
    else {
      setPinnedVideoId(id);
      handleNotifyPinUser(id);
      antmedia.assignVideoTrack(videoLabel, id, true);
    }
  }


  function handleSetMaxVideoTrackCount(maxTrackCount: number) {
    // I am changing maximum participant number on the screen. Default is 3.
    if (myLocalData?.streamId) {
      antmedia.setMaxVideoTrackCount(myLocalData.streamId, maxTrackCount);
      globals.maxVideoTrackCount = maxTrackCount;
    }
  }
  function handleStartScreenShare() {
    if (myLocalData)
      antmedia.switchDesktopCapture(myLocalData.streamId).catch(() => { });
  }

  const screenShareOnNotification = () => {
    if (!myLocalData)
      return;
    setIsScreenShared(true);
    antmedia.screenShareOffNotification();
    const requestedMediaConstraints = {
      width: 1920,
      height: 1080,
    };
    antmedia.applyConstraints(myLocalData.streamId, requestedMediaConstraints);
    antmedia.handleSendNotificationEvent(
      "SCREEN_SHARED_ON",
      myLocalData.streamId
    );

    setPinnedVideoId("localVideo");
    // send fake audio level to get screen sharing user on a videotrack
    antmedia.updateAudioLevel(myLocalData.streamId, 10);

  }
  const handleScreenshareNotFromPlatform = () => {
    if (!myLocalData)
      return;
    setIsScreenShared(false);
    if (
      cam.find(
        (c) => c.eventStreamId === "localVideo" && c.isCameraOn === false
      )
    ) {
      antmedia.turnOffLocalCamera(myLocalData.streamId);
    } else {
      antmedia.switchVideoCameraCapture(myLocalData.streamId).catch(() => { });
    }
    antmedia.screenShareOffNotification();
    const requestedMediaConstraints = {
      width: 320,
      height: 240,
    };
    antmedia.applyConstraints(myLocalData.streamId, requestedMediaConstraints);
  }
  const handleStopScreenShare = () => {
    if (!myLocalData)
      return;
    setIsScreenShared(false);
    if (
      cam.find(
        (c) => c.eventStreamId === "localVideo" && c.isCameraOn === false
      )
    ) {
      antmedia.turnOffLocalCamera(myLocalData.streamId);
    } else {
      antmedia.switchVideoCameraCapture(myLocalData.streamId).catch(() => { });

    }
    antmedia.screenShareOffNotification();
  }
  const handleSetMessages = (newMessage: any) => {
    setMessages((oldMessages) => {
      let lastMessage = oldMessages[oldMessages.length - 1]; //this must remain mutable
      const isSameUser = lastMessage?.name === newMessage?.name;
      const sentInSameTime = lastMessage?.date === newMessage?.date;

      if (isSameUser && sentInSameTime) {
        //group the messages *sent back to back in the same timeframe by the same user* by joinig the new message text with new line
        lastMessage.message = lastMessage.message + "\n" + newMessage.message;
        return [...oldMessages]; // dont make this "return oldMessages;" this is to trigger the useEffect for scroll bottom and get over showing the last prev state do
      } else {
        return [...oldMessages, newMessage];
      }
    });
  }
  const scrollToBottom = () => {
    let objDiv = document.getElementById("paper-props");
    if (objDiv) objDiv.scrollTop = objDiv?.scrollHeight;
  }
  useEffect(() => {
    scrollToBottom();
  }, [messages]);


  const handleDrawerOpen = (open: boolean) => {
    setDrawerOpen(open);
  }

  const handleSendMessage = (message: any) => {
    if (!myLocalData)
      return;

    if (myLocalData.streamId) {
      const iceState = antmedia.iceConnectionState(myLocalData.streamId);
      if (
        iceState !== null &&
        iceState !== "failed" &&
        iceState !== "disconnected"
      ) {
        antmedia.sendData(
          myLocalData.streamId,
          JSON.stringify({
            eventType: "MESSAGE_RECEIVED",
            message: message,
            name: streamName,
            date: new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
          })
        );
      }
    }
  }
  const toggleSetCam = (data: any) => {
    setCam((camList) => {
      let arr = _.cloneDeep(camList);
      let camObj = arr.find((c) => c.eventStreamId === data.eventStreamId);

      if (camObj) {
        camObj.isCameraOn = data.isCameraOn;
      } else {
        arr.push(data);
      }

      return arr;
    });
  }

  const toggleSetMic = (data: any) => {
    setMic((micList) => {
      let arr = _.cloneDeep(micList);
      let micObj = arr.find((c) => c.eventStreamId === data.eventStreamId);

      if (micObj) {
        micObj.isMicMuted = data.isMicMuted;
      } else {
        arr.push(data);
      }

      return arr;
    });
  }
  function toggleSetNumberOfUnreadMessages(numb: number) {
    setNumberOfUnReadMessages(numb);
  }
  const setUserStatus = (notificationEvent: { isScreenShared: any; mic: any; camera: any; }, eventStreamId: string) => {
    if (notificationEvent.isScreenShared) {
      // if the participant was already pin someone than we should not update it
      if (!screenSharedVideoId) {
        setScreenSharedVideoId(eventStreamId);
        let videoLab = participants.find((p) => p.id === eventStreamId)
          ?.videoLabel
          ? participants.find((p) => p.id === eventStreamId).videoLabel
          : "";
        if (eventStreamId != null)
          pinVideo(eventStreamId, videoLab);
      }
    }

    if (!isScreenShared && participants.find((p) => p.id === eventStreamId)) {
      if (!mic.find((m) => m.eventStreamId === eventStreamId)) {
        toggleSetMic({
          eventStreamId: eventStreamId,
          isMicMuted: notificationEvent.mic,
        });
      }
      if (!cam.find((m) => m.eventStreamId === eventStreamId)) {
        toggleSetCam({
          eventStreamId: eventStreamId,
          isCameraOn: notificationEvent.camera,
        });
      }
    }
  }
  const unpinUser = (notificationEvent: any) => {
    if (!myLocalData)
      return;
    if (
      notificationEvent.streamId === myLocalData.streamId &&
      !isScreenShared
    ) {
      let requestedMediaConstraints = {
        width: 320,
        height: 240,
      };
      antmedia.applyConstraints(
        myLocalData.streamId,
        requestedMediaConstraints
      );
    }
  }
  const pinUser = (notificationEvent: any) => {
    if (!myLocalData)
      return;
    if (
      notificationEvent.streamId === myLocalData.streamId &&
      !isScreenShared
    ) {
      let requestedMediaConstraints = {
        width: 640,
        height: 480,
      };
      antmedia.applyConstraints(
        myLocalData.streamId,
        requestedMediaConstraints
      );
    }
  }
  const videoTrackAssignmentChange = (notificationEvent: any) => {
    if (!notificationEvent.payload.trackId) {
      return;
    }
    setParticipants((oldParticipants) => {
      return oldParticipants
        // .filter(
        //   (p) =>
        //     p.videoLabel === notificationEvent.payload.videoLabel ||
        //     p.id !== notificationEvent.payload.trackId
        // )
        .map((p) => {
          if (
            p.videoLabel === notificationEvent.payload.videoLabel &&
            p.id !== notificationEvent.payload.trackId
          ) {
            return {
              ...p,
              id: notificationEvent.payload.trackId,
              oldId: p.id,
            };
          }
          return p;
        });
    });
  }
  const audioTracksAssignmentChange = (notificationEvent: any) => {
    if (!myLocalData)
      return;
    clearInterval(timeoutRef.current as NodeJS.Timeout);
    timeoutRef.current = setTimeout(() => {
      setTalkers([]);
    }, 1000);
    setTalkers((oldTalkers) => {
      const newTalkers = notificationEvent.payload
        .filter(
          (p: any) =>
            p.trackId !== "" &&
            screenSharedVideoId !== p.trackId &&
            p.audioLevel !== 0
        )
        .map((p: any) => p.trackId);
      return _.isEqual(oldTalkers, newTalkers) ? oldTalkers : newTalkers;
    });
  }

  function eventCheck(notificationEvent: any, eventType: any, eventStreamId: any) {
    switch (eventType) {

      case "CAM_TURNED_OFF":
        toggleSetCam({
          eventStreamId: eventStreamId,
          isCameraOn: false,
        });
        break;
      case "CAM_TURNED_ON":
        toggleSetCam({
          eventStreamId: eventStreamId,
          isCameraOn: true,
        });
        break;
      case "MIC_MUTED":
        toggleSetMic({
          eventStreamId: eventStreamId,
          isMicMuted: true,
        });
        break;
      case "MIC_UNMUTED":
        toggleSetMic({
          eventStreamId: eventStreamId,
          isMicMuted: false,
        });
        break;
      case "MESSAGE_RECEIVED":
        if (!drawerOpen) {
          setNumberOfUnReadMessages((numb) => numb + 1);
        }
        setMessages((oldMessages) => {
          let lastMessage = oldMessages[oldMessages.length - 1]; //this must remain mutable
          const isSameUser = lastMessage?.name === notificationEvent?.name;
          const sentInSameTime = lastMessage?.date === notificationEvent?.date;

          if (isSameUser && sentInSameTime) {
            //group the messages *sent back to back in the same timeframe by the same user* by joinig the new message text with new line
            lastMessage.message =
              lastMessage.message + "\n" + notificationEvent.message;
            return [...oldMessages]; // dont make this "return oldMessages;" this is to trigger the useEffect for scroll bottom and get over showing the last prev state do
          } else {
            return [...oldMessages, notificationEvent];
          }
        });
        break;
      case "SCREEN_SHARED_ON":
        {
          let videoLab = participants.find((p) => p.id === eventStreamId)
            ?.videoLabel
            ? participants.find((p) => p.id === eventStreamId).videoLabel
            : "";
          pinVideo(eventStreamId, videoLab);
          setScreenSharedVideoId(eventStreamId);
        }
        break;
      case "SCREEN_SHARED_OFF":
        setScreenSharedVideoId(null);
        setPinnedVideoId(null);
        break;
      case "UPDATE_STATUS":
        setUserStatus(notificationEvent, eventStreamId);
        break;
      case "PIN_USER":
        pinUser(notificationEvent)
        break;
      case "UNPIN_USER":
        unpinUser(notificationEvent)
        break;
      case "VIDEO_TRACK_ASSIGNMENT_CHANGE":
        videoTrackAssignmentChange(notificationEvent)
        break;
      case "AUDIO_TRACK_ASSIGNMENT":
        audioTracksAssignmentChange(notificationEvent)

        break;
    }
  }

  function handleNotificationEvent(obj: any) {
    const notificationEvent = JSON.parse(obj.data);
    if (notificationEvent != null && typeof notificationEvent == "object") {
      const eventStreamId = notificationEvent.streamId;
      const eventType = notificationEvent.eventType;
      eventCheck(notificationEvent, eventType, eventStreamId)

    }
  }

  function handleLeaveFromRoom() {
    // we need to empty participant array. i f we are going to leave it in the first place.
    setParticipants([]);
    antmedia.leaveFromRoom(roomName);
    if (myLocalData)
      antmedia.turnOffLocalCamera(myLocalData.streamId);
    setMeetingStatus("close");
    console.log("init close handle leave")
  }

  function handleRoomInfo(publishStreamId: string) {
    antmedia.getRoomInfo(roomName, publishStreamId);
    setIsPublished(true);
  }

  function updateStatus(obj: any) {
    if (roomName !== obj) {
      if (!myLocalData)
        return;
      handleSendNotificationEvent("UPDATE_STATUS", myLocalData.streamId, {
        mic: !!mic.find((c) => c.eventStreamId === "localVideo")?.isMicMuted,
        camera: !!cam.find((c) => c.eventStreamId === "localVideo")?.isCameraOn,
        isPinned:
          pinnedVideoId === "localVideo" ? myLocalData.streamId : pinnedVideoId,
        isScreenShared: isScreenShared,
      });
    }
  }
  function handleSetMyObj(obj: any) {
    setMyLocalData({ ...obj, streamName });
  }
  function handlePlay(token: any, tempList: any) {
    antmedia.play(roomName, token, roomName, tempList);
  }
  function handleStreamInformation(obj: any) {
    antmedia.play(obj.streamId, "", roomName);
  }
  function handlePublish(publishStreamId: string, token: any, subscriberId: string, subscriberCode: string) {
    antmedia.publish(
      publishStreamId,
      token,
      subscriberId,
      subscriberCode,
      streamName,
      roomName,
      "{someKey:somveValue}"
    );
  }
  function handlePlayVideo(obj: any, publishStreamId: string) {
    let index = obj?.trackId?.substring("ARDAMSx".length);

    if (obj.track.kind === "audio") {
      setAudioTracks((sat) => {
        return [
          ...sat,
          {
            id: index,
            track: obj.track,
            streamId: obj.streamId,
          },
        ];
      });
      return;
    }
    if (index === publishStreamId) {
      return;
    }
    if (index === roomName) {
      return;
    } else if (obj?.trackId && !participants.some((p) => p.id === index)) {
      setParticipants((spp) => {

        return [
          ...spp.filter((p) => p.id !== index),
          {
            id: index,
            videoLabel: index,
            track: obj.track,
            streamId: obj.streamId,
            isCameraOn: true,
            name: "",
          },
        ];
      });

    }
  }
  function handleRoomEvents({ streams, streamList }: { streams: any[], streamList: any[] }) {
    setAllParticipants(streamList);
    setParticipants((oldParts) => {
      if (streams.length < participants.length) {
        return oldParts.filter((p) => streams.includes(p.id));
      }
      // matching the names.
      return oldParts.map((p) => {

        const newName = streamList.find((s: any) => s.streamId === p.id)?.streamName;
        if (p.name !== newName) {
          return { ...p, name: newName };
        }
        return p;
      });
    });
    if (pinnedVideoId !== "localVideo" && !streams.includes(pinnedVideoId)) {
      setPinnedVideoId(null);
    }
  }

  // START custom functions
  antmedia.handlePlayVideo = handlePlayVideo;
  antmedia.handleRoomEvents = handleRoomEvents;
  antmedia.handlePublish = handlePublish;
  antmedia.handleStreamInformation = handleStreamInformation;
  antmedia.handlePlay = handlePlay;
  antmedia.handleRoomInfo = handleRoomInfo;
  antmedia.updateStatus = updateStatus;
  antmedia.handleSetMyObj = handleSetMyObj;
  antmedia.handleSendNotificationEvent = handleSendNotificationEvent;
  antmedia.handleNotificationEvent = handleNotificationEvent;
  antmedia.handleLeaveFromRoom = handleLeaveFromRoom;
  antmedia.handleSendMessage = handleSendMessage;
  antmedia.screenShareOffNotification = screenShareOffNotification;
  antmedia.screenShareOnNotification = screenShareOnNotification;
  antmedia.handleStartScreenShare = handleStartScreenShare;
  antmedia.handleStopScreenShare = handleStopScreenShare;
  antmedia.handleScreenshareNotFromPlatform = handleScreenshareNotFromPlatform;
  antmedia.handleNotifyPinUser = handleNotifyPinUser;
  antmedia.handleNotifyUnpinUser = handleNotifyUnpinUser;
  antmedia.handleSetMaxVideoTrackCount = handleSetMaxVideoTrackCount;
  // END custom functions

  console.log("di dms", meetingStatus)
  const settingsValue = {
    mic,
    cam,
    toggleSetCam,
    drawerOpen,
    handleDrawerOpen,
    handleSetMessages,
    messages,
    toggleSetNumberOfUnreadMessages,
    numberOfUnReadMessages,
    pinVideo,
    pinnedVideoId,
    screenSharedVideoId,
    audioTracks,
    allParticipants,
    globals,
  }
  const settingsContextObj = useMemo(() => settingsValue, [
    isScreenShared,
    mic,
    cam,
    talkers,
    toggleSetCam,
    toggleSetMic,
    myLocalData,
    handleDrawerOpen,
    screenSharedVideoId,
    audioTracks,
    isPublished,
    setSelectedCamera,
    selectedCamera,
    selectedMicrophone,
    setSelectedMicrophone,
    setParticipants,
    participants,
    customerName
  ]);
  const contextValue = {
    isScreenShared,
    mic,
    cam,
    talkers,
    toggleSetCam,
    toggleSetMic,
    myLocalData,
    handleDrawerOpen,
    screenSharedVideoId,
    audioTracks,
    isPublished,
    setSelectedCamera,
    selectedCamera,
    selectedMicrophone,
    setSelectedMicrophone,
    setParticipants,
    participants,
    customerName
  }
  const contextObj = useMemo(() => contextValue, [
    isScreenShared,
    mic,
    cam,
    talkers,
    toggleSetCam,
    toggleSetMic,
    myLocalData,
    handleDrawerOpen,
    screenSharedVideoId,
    audioTracks,
    isPublished,
    setSelectedCamera,
    selectedCamera,
    selectedMicrophone,
    setSelectedMicrophone,
    setParticipants,
    participants,
    customerName
  ]); // value is cached by useMemo

  const loadDMSComponent = () => {
    if (meetingStatus === "waiting-video-dms" || meetingStatus === "missing-video-dms")

      return (<MiniVideoCallControl
        meetingStatus={meetingStatus}
        streamName={streamName}
        handleStreamName={(name) => setStreamName(name)}
        handleChangeRoomStatus={(status) => {
          if (status.includes("waiting") || status.includes("missing") || status.includes("meeting"))
            setMeetingStatus(status)
          else {
            setMeetingStatus(status)
          }
        }
        }
      ></MiniVideoCallControl>)
    else if (meetingStatus === "waiting-audio-dms" || meetingStatus === "missing-audio-dms")
      return (<MiniAudioCallControl
        meetingStatus={meetingStatus}
        streamName={streamName}
        handleStreamName={(name) => setStreamName(name)}
        handleChangeRoomStatus={(status) => {
          if (status.includes("waiting") || status.includes("missing") || status.includes("meeting"))
            setMeetingStatus(status)
          else {
            setMeetingStatus(status)
          }
        }
        }
      ></MiniAudioCallControl>)
    else {

      return (
        <SettingsContext.Provider
          value={settingsContextObj}
        >
          <>
            {meetingStatus === "meeting-video-dms" &&
              <VideoCallControl
                participants={participants}
                allParticipants={allParticipants}
                myLocalData={myLocalData}
                roomName={roomName}
              ></VideoCallControl>
            }
            {meetingStatus === "meeting-audio-dms" &&
              <AudioCallControl
                participants={participants}
                allParticipants={allParticipants}
                myLocalData={myLocalData}
                roomName={roomName}
              ></AudioCallControl>
            }
          </>
        </SettingsContext.Provider>
      )
    }
  }
  return (

    <MediaSettingsContext.Provider
      value={contextObj}
    >

      {loadDMSComponent()}
    </MediaSettingsContext.Provider>

  );
}

export default DMSMedia;

